/* @flow */

import React from 'react';

import LoadingComponent from 'components/loading';

import DebtorInfoFormViewComponent from './view';

import DebtorInfo from 'models/debtors/debtorInfo';
import DebtorInfoForm from './model';

import {handleFormChange, handleFormValidation} from 'lib/forms';
import loadConstraints from 'lib/validation/loadConstraints';

type DebtorInfoFormComponentProps = {
  successHandler: (form: DebtorInfo) => void;
}

type DebtorInfoFormComponentState = {
  constraints: any;
  errors: Map<string, ?string>;
  form: DebtorInfoForm;
  isLoading: boolean;
}

class DebtorInfoFormComponent extends React.Component<DebtorInfoFormComponentProps, DebtorInfoFormComponentState> {

  constructor(props) {
    super(props);

    this.state = {
      constraints: null,
      errors: null,
      form: new DebtorInfoForm(),
      isLoading: true
    };
  }

  componentDidMount = async () => {
    try {
      const constraints = await loadConstraints('Person', ['firstName', 'lastName', 'email', 'functionName']);
      this.setState({
        constraints,
        errors: new Map(Object.keys(constraints).map(e => [e, undefined])),
        isLoading: false
      });
    } catch (e) {
      console.error(e);
    }
  };

  handleChange = (fieldName: string) => (event) => handleFormChange.call(this, fieldName, event.target.value);
  validateForm = () => handleFormValidation.call(this);
  
  submitForm = async () => {
    if (!this.validateForm()) return;
    this.props.successHandler(this.state.form.toModel());
  };

  render() {
    if (this.state.isLoading) {
      return <LoadingComponent />;
    }

    return (
      <DebtorInfoFormViewComponent
        errors={this.state.errors}
        form={this.state.form}
        handleChange={this.handleChange}
        submitForm={this.submitForm}
      />
    );
  }
}

export default DebtorInfoFormComponent;
